export type ConsentCategories = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};

export type ConsentState = {
  version: 1;
  decidedAt: string;
  categories: ConsentCategories;
};

const KEY = "perceptica.consent.v1";

export function readConsent(): ConsentState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentState;
    if (parsed?.version !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent(categories: Omit<ConsentCategories, "necessary"> & { necessary?: true }): ConsentState {
  const next: ConsentState = {
    version: 1,
    decidedAt: new Date().toISOString(),
    categories: { necessary: true, analytics: !!categories.analytics, marketing: !!categories.marketing },
  };
  if (typeof window !== "undefined") {
    window.localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("perceptica:consent", { detail: next }));
  }
  return next;
}

export function clearConsent() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent("perceptica:consent", { detail: null }));
}

export function subscribeConsent(cb: (s: ConsentState | null) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const handler = (e: Event) => cb((e as CustomEvent<ConsentState | null>).detail);
  window.addEventListener("perceptica:consent", handler);
  return () => window.removeEventListener("perceptica:consent", handler);
}